export default __webpack_public_path__ + "static/andre-c77df718cd9f6101b37b7b5443fd61e3.png";